import i18next from 'helpers/i18n';

export const getLabelWithLang = (code, defaultText, params) => i18next.t(code, defaultText, params);
